module.exports = __webpack_public_path__ + "img/w3_store_grey.38779ba4.png";